import "./index.scss";
import React, { useRef, useState } from "react";
import SubmitBtn from "../submitButton";

function SetCodeForm({ setCurrentStep = () => {} }) {
  const [loading, setloading] = useState(false);
  const [errors, setErrors] = useState({ hasError: false, msg: "" });
  const inputsRef = useRef([]);

  const handleInputChange = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    e.target.value = value;

    if (value && index < inputsRef.current.length - 1) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && index > 0 && !e.target.value) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setloading(true);

    const code = inputsRef.current.map((input) => input.value).join("");

    if (code.length !== 6) {
      setErrors({
        hasError: true,
        msg: "Le code doit avoir 6 chiffres!",
      });
      setloading(false);
      return;
    }

    localStorage.setItem("resetPwdCode", code);
    setloading(false);
    setCurrentStep(3);
  };

  return (
    <form
      id="SetCodeForm"
      className="form-group"
      onSubmit={handleSubmit}
      aria-busy={loading}
    >
      <div className="error-msg">{errors.hasError && <p>{errors.msg}</p>}</div>
      <div className="code-inputs">
        {[...Array(6)].map((_, index) => (
          <input
            key={index}
            type="text"
            className="form__input"
            maxLength="1"
            ref={(el) => (inputsRef.current[index] = el)}
            onChange={(e) => handleInputChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
          />
        ))}
      </div>
      <SubmitBtn value="Vérifier le code" disabled={loading} />
      <button
        className="btn-back"
        onClick={(e) => {
          setCurrentStep(1);
        }}
      >
        {`< Retour à l’étape précédente`}
      </button>
    </form>
  );
}

export default SetCodeForm;
